import React from 'react';
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  SxProps,
} from '@mui/material';

import {
  ISubmission,
  ISubmissionQuestion,
} from '../../../../store/SubmissionSlice';
import { IQuestionDetailAnswer } from '../../../../store/QuestionSlice';
import { TP_COLORS } from '../../../../constants';

type TAnswerListItemProps = {
  answer: IQuestionDetailAnswer;
  answers: Array<IQuestionDetailAnswer>;
  submission: ISubmission;
  selectedQuestion: ISubmissionQuestion;
  onClick?: () => void;
  isDisabled?: boolean;
};

const containerStyles: SxProps = {
  borderRadius: '100px',
};

const avatarStyles: SxProps = {
  width: '40px',
  height: '40px',
  color: TP_COLORS.black,
  fontSize: '100%',
  fontWeight: 600,
  backgroundColor: 'rgba(241, 245, 249, 1)',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#CBD5E1',
};

const AnswerListItem: React.FC<TAnswerListItemProps> = ({
  answer,
  answers = [],
  submission,
  selectedQuestion,
  onClick = undefined,
  isDisabled = false,
}) => {
  const orderNumber = (answer.order + 1).toString().padStart(2, '0');
  const correctAnswers = answers.filter((item) => item.isCorrect);

  const highlightedStyles: SxProps = {
    backgroundColor: undefined,
    color: undefined,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'transparent',
  };

  if (submission.status === 'pending') {
    if (
      selectedQuestion &&
      selectedQuestion.status === 'skipped' &&
      correctAnswers.some((item) => item._id === answer._id)
    ) {
      highlightedStyles.backgroundColor = '#D3FCD2';
      highlightedStyles.borderColor = '#22C55E';
    } else if (
      selectedQuestion.status !== 'skipped' &&
      selectedQuestion &&
      selectedQuestion.answer &&
      selectedQuestion.answer._id === answer._id
    ) {
      highlightedStyles.backgroundColor = '#01A79F';
    }
  } else if (submission.status === 'completed') {
    if (
      selectedQuestion &&
      selectedQuestion.answer &&
      selectedQuestion.answer._id === answer._id &&
      answer.isCorrect
    ) {
      highlightedStyles.backgroundColor = '#D3FCD2';
      highlightedStyles.borderColor = '#22C55E';
    } else if (
      selectedQuestion &&
      selectedQuestion.answer &&
      selectedQuestion.answer._id === answer._id &&
      !answer.isCorrect
    ) {
      highlightedStyles.backgroundColor = '#FFE9D5';
      highlightedStyles.borderColor = '#FF5630';
    }

    if (correctAnswers.some((item) => item._id === answer._id)) {
      highlightedStyles.backgroundColor = '#D3FCD2';
      highlightedStyles.borderColor = '#22C55E';
    }
  }

  return (
    <Card sx={{ ...containerStyles, ...highlightedStyles }} onClick={onClick}>
      <CardActionArea disabled={isDisabled}>
        <CardContent style={{ padding: '10px' }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={2} sm={2} style={{ maxWidth: '50px' }}>
              <Avatar sx={avatarStyles}>{orderNumber}</Avatar>
            </Grid>
            <Grid item xs={10}>
              <div
                className="view ql-editor ql-viewer"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: answer.content }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AnswerListItem;
